import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
  subcategories: string[];
}

// Font Awesome 아이콘 → SVG 매핑 (경량)
const ICON_MAP: Record<string, string> = {
  laptop: "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z",
  desktop: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z",
  mobile: "M15.5 1h-8A2.5 2.5 0 005 3.5v17A2.5 2.5 0 007.5 23h8a2.5 2.5 0 002.5-2.5v-17A2.5 2.5 0 0015.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z",
  wrench: "M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z",
  utensils: "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z",
  home: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z",
  plug: "M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-1.99-1.99-1.99z",
  lightbulb: "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7z",
  tent: "M12 2L2 22h20L12 2zm0 4.5L18 20H6l6-13.5z",
  car: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z",
  gamepad: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
  bicycle: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z",
  baby: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 7c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z",
  heart: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z",
  shield: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z",
  couch: "M21 9V7c0-1.65-1.35-3-3-3H6C4.35 4 3 5.35 3 7v2c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3zM5 7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v2.78c-.61.55-1 1.34-1 2.22v2H6v-2c0-.88-.39-1.67-1-2.22V7z",
  clock: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z",
  pen: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z",
  paw: "M4.5 11c1.38 0 2.5-1.79 2.5-4S5.88 3 4.5 3 2 4.79 2 7s1.12 4 2.5 4zm15 0c1.38 0 2.5-1.79 2.5-4s-1.12-4-2.5-4S17 4.79 17 7s1.12 4 2.5 4zm-2 1c-1.34 0-2.62.76-3.5 2-1.08-1.44-2.12-2-3-2-1.34 0-2.62.76-3.5 2-.88-1.24-2.16-2-3.5-2C2.01 12 0 14.69 0 18c0 1.66 1.34 3 3 3h18c1.66 0 3-1.34 3-3 0-3.31-2.01-6-4.5-6zM8 7c0-2.21-1.12-4-2.5-4S3 4.79 3 7s1.12 4 2.5 4S8 9.21 8 7zm8 0c0-2.21-1.12-4-2.5-4S11 4.79 11 7s1.12 4 2.5 4S16 9.21 16 7z",
  suitcase: "M17 6V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H2v13c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6h-5zM9 4h6v2H9V4z",
  ellipsis: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
};

const Header: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [categories, setCategories] = useState<Category[]>([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [hoveredCat, setHoveredCat] = useState<string | null>(null);
  const [deploying, setDeploying] = useState(false);
  const [deployLog, setDeployLog] = useState<string[]>([]);
  const [deployResult, setDeployResult] = useState<{show:boolean, success:boolean, message:string}>({show:false, success:false, message:''});
  const menuRef = useRef<HTMLDivElement>(null);
  const menuTimerRef = useRef<number | null>(null);
  const navigate = useNavigate();
  const { member, logout } = useAuth();
  const { count: cartCount } = useCart();

  // 카테고리 한 번만 로드
  useEffect(() => {
    const ctrl = new AbortController();
    fetch('/api/storefront/categories', { signal: ctrl.signal })
      .then(r => r.json())
      .then(d => { if (d.categories) setCategories(d.categories); })
      .catch(() => {});
    return () => ctrl.abort();
  }, []);

  const handleSearch = () => {
    const q = searchQuery.trim();
    if (q) {
      navigate(`/?search=${encodeURIComponent(q)}`);
    } else {
      navigate('/');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleSearch();
  };

  const handleDeploy = async () => {
    if (!window.confirm('홈페이지를 서버에 배포하시겠습니까?\n\n① React 빌드\n② 서버 업로드\n③ 서버 재시작')) return;
    setDeploying(true);
    setDeployLog([]);
    setDeployResult({show:false, success:false, message:''});
    try {
      const resp = await fetch('/api/storefront/deploy', { method: 'POST' });
      if (!resp.ok) {
        const errData = await resp.json().catch(() => ({ error: `HTTP ${resp.status}` }));
        setDeployResult({show:true, success:false, message: errData.error || `서버 오류 (${resp.status})`});
        return;
      }
      const reader = resp.body?.getReader();
      const decoder = new TextDecoder();
      if (!reader) {
        setDeployResult({show:true, success:false, message: '스트림 읽기 실패'});
        return;
      }
      let buf = '';
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        const lines = buf.split('\n');
        buf = lines.pop() || '';
        for (const line of lines) {
          if (!line.startsWith('data: ')) continue;
          try {
            const ev = JSON.parse(line.slice(6));
            if (ev.type === 'progress') {
              setDeployLog(prev => [...prev, ev.message]);
            } else if (ev.type === 'error') {
              setDeployLog(prev => [...prev, `❌ ${ev.message}`]);
            } else if (ev.type === 'done') {
              setDeployResult({show:true, success:ev.success, message:ev.message});
            }
          } catch(parseErr) { console.warn('SSE parse error:', parseErr); }
        }
      }
    } catch (e) {
      const msg = e instanceof Error ? e.message : String(e);
      setDeployResult({show:true, success:false, message:`네트워크 오류: ${msg}`});
    } finally {
      setDeploying(false);
    }
  };

  const handleShutdown = async () => {
    if (!window.confirm('홈페이지 서버를 종료하시겠습니까?')) return;
    try {
      await fetch('/api/storefront/shutdown', { method: 'POST' });
    } catch {}
    setTimeout(() => window.close(), 500);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const openMenu = useCallback(() => {
    if (menuTimerRef.current) { clearTimeout(menuTimerRef.current); menuTimerRef.current = null; }
    setMenuOpen(true);
  }, []);

  const closeMenuDelayed = useCallback(() => {
    menuTimerRef.current = window.setTimeout(() => setMenuOpen(false), 200);
  }, []);

  const handleCatClick = (catId: string) => {
    setMenuOpen(false);
    window.open(`/shop/category/${catId}`, '_blank');
  };

  // 메가메뉴 외부 클릭 닫기 + 타이머 정리
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (menuTimerRef.current) clearTimeout(menuTimerRef.current);
    };
  }, []);

  return (
    <>
    <header className="header notranslate" translate="no">
      <div className="header-inner">
        <a href="/shop" className="logo" onClick={() => { setSearchQuery(''); }}>
          <img src="/logo.png" alt="WORLDSHIP" className="logo-img" />
          <div className="logo-text">
            <span className="logo-main">WorldShip</span>
          </div>
        </a>
        <div className="search-bar">
          <input
            type="text"
            placeholder="상품 검색..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <button onClick={handleSearch}>
            <svg viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </button>
        </div>
        <div className="header-actions">
          {member ? (
            <>
              <Link to="/mypage" className="header-action">
                <svg viewBox="0 0 24 24" fill="#666">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
                {member.name}
              </Link>
              <div className="header-action" onClick={handleLogout}>
                <svg viewBox="0 0 24 24" fill="#666">
                  <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
                </svg>
                Logout
              </div>
            </>
          ) : (
            <>
              <Link to="/order/lookup" className="header-action">
                <svg viewBox="0 0 24 24" fill="#666">
                  <path d="M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15H3V6h18v13zM4 9h5v5H4z"/>
                </svg>
                주문조회
              </Link>
              <Link to="/register" className="header-action">
                <svg viewBox="0 0 24 24" fill="#666">
                  <path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
                회원가입
              </Link>
              <Link to="/login" className="header-action">
                <svg viewBox="0 0 24 24" fill="#666">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
                로그인
              </Link>
            </>
          )}
          <Link to="/cart" className="header-action" style={{ position: 'relative' }}>
            <svg viewBox="0 0 24 24" fill="#666">
              <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020.01 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
            </svg>
            장바구니
            {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
          </Link>
          {isLocal && (
            <>
              <div className="header-action" onClick={handleDeploy} style={{ cursor: deploying ? 'wait' : 'pointer', color: deploying ? '#999' : '#2563eb', opacity: deploying ? 0.6 : 1 }}>
                <svg viewBox="0 0 24 24" fill={deploying ? '#999' : '#2563eb'} width="24" height="24">
                  <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
                </svg>
                {deploying ? '배포중...' : '배포'}
              </div>
              <div className="header-action" onClick={handleShutdown} style={{ cursor: 'pointer', color: '#ef4444' }}>
                <svg viewBox="0 0 24 24" fill="#ef4444" width="24" height="24">
                  <path d="M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"/>
                </svg>
                Exit
              </div>
            </>
          )}
        </div>
      </div>

      {/* ── 카테고리 네비게이션 바 ── */}
      {categories.length > 0 && (
        <div className="category-nav" ref={menuRef}>
          <div className="category-nav-inner">
            <div
              className={`category-trigger${menuOpen ? ' active' : ''}`}
              onMouseEnter={openMenu}
              onMouseLeave={closeMenuDelayed}
              onClick={() => setMenuOpen(v => !v)}
            >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
              </svg>
              <span>전체 카테고리</span>
              <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" style={{transition:'transform .2s', transform: menuOpen ? 'rotate(180deg)' : 'none'}}>
                <path d="M7 10l5 5 5-5z"/>
              </svg>
            </div>

            {/* 인기 카테고리 퀵링크 */}
            <div className="category-quicklinks">
              {categories.slice(0, 8).map(c => (
                <a key={c.id} href={`/shop/category/${c.id}`} target="_blank" rel="noopener noreferrer" className="category-quicklink">
                  {c.name}
                </a>
              ))}
            </div>
          </div>

          {/* ── 메가메뉴 드롭다운 ── */}
          {menuOpen && (
            <div
              className="mega-menu"
              onMouseEnter={openMenu}
              onMouseLeave={closeMenuDelayed}
            >
              {/* 좌측: 대분류 목록 */}
              <div className="mega-menu-left">
                {categories.map(c => (
                  <div
                    key={c.id}
                    className={`mega-menu-item${hoveredCat === c.id ? ' active' : ''}`}
                    onMouseEnter={() => setHoveredCat(c.id)}
                    onClick={() => handleCatClick(c.id)}
                  >
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="#555">
                      <path d={ICON_MAP[c.icon] || ICON_MAP.ellipsis} />
                    </svg>
                    <span className="mega-menu-name">{c.name}</span>
                    <span className="mega-menu-count">{c.count.toLocaleString()}</span>
                    {c.subcategories.length > 0 && (
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="#aaa" className="mega-menu-arrow">
                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                      </svg>
                    )}
                  </div>
                ))}
              </div>

              {/* 우측: 중분류 (호버 시 표시) */}
              {hoveredCat && (() => {
                const cat = categories.find(c => c.id === hoveredCat);
                if (!cat || cat.subcategories.length === 0) return null;
                return (
                  <div className="mega-menu-right">
                    <h3 className="mega-menu-right-title">{cat.name}</h3>
                    <div className="mega-menu-subs">
                      {cat.subcategories.map((sub, i) => (
                        <a
                          key={i}
                          href={`/shop/category/${cat.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="mega-menu-sub"
                          onClick={() => setMenuOpen(false)}
                        >
                          {sub}
                        </a>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      )}
    </header>

      {/* 배포 진행 모달 */}
      {(deploying || deployResult.show) && (
        <div style={{
          position:'fixed', top:0, left:0, right:0, bottom:0,
          background:'rgba(0,0,0,0.6)', zIndex:10000,
          display:'flex', alignItems:'center', justifyContent:'center'
        }} onClick={() => { if (!deploying) setDeployResult({show:false,success:false,message:''}); }}>
          <div style={{
            background:'#fff', borderRadius:16,
            width:'95vw', maxHeight:'90vh', overflow:'hidden',
            display:'flex', flexDirection:'column',
            boxShadow:'0 25px 50px -12px rgba(0,0,0,0.25)', margin:'0 16px'
          }} onClick={e => e.stopPropagation()}>
            {/* 헤더 */}
            <div style={{
              padding:'16px 24px', display:'flex', alignItems:'center', gap:8,
              background:'linear-gradient(to right, #2563eb, #1d4ed8)', color:'#fff', flexShrink:0
            }}>
              <svg viewBox="0 0 24 24" fill="#fff" width="22" height="22">
                <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
              </svg>
              <h3 style={{margin:0, fontSize:18, fontWeight:700}}>서버 배포</h3>
            </div>
            {/* 본문 */}
            <div style={{padding:'20px 24px', overflow:'auto', flex:1}}>

            {/* 진행 로그 */}
            <div style={{
              background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:8,
              padding:'16px 20px', fontSize:14, lineHeight:2, minHeight:200,
              fontFamily:'monospace', color:'#334155'
            }}>
              {deployLog.length === 0 && deploying && <span style={{color:'#94a3b8'}}>배포 준비 중...</span>}
              {deployLog.map((log, i) => <div key={i}>{log}</div>)}
            </div>

            {/* 로딩 인디케이터 */}
            {deploying && (
              <div style={{textAlign:'center', marginTop:16}}>
                <div style={{
                  width:28, height:28, border:'3px solid #e2e8f0', borderTop:'3px solid #2563eb',
                  borderRadius:'50%', animation:'spin 1s linear infinite', margin:'0 auto'
                }}/>
                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
              </div>
            )}

            {/* 결과 */}
            {deployResult.show && (
              <div style={{
                marginTop:16, padding:'12px 16px', borderRadius:8,
                background: deployResult.success ? '#f0fdf4' : '#fef2f2',
                border: `1px solid ${deployResult.success ? '#bbf7d0' : '#fecaca'}`,
                color: deployResult.success ? '#166534' : '#991b1b',
                fontSize:14, fontWeight:600
              }}>
                {deployResult.message}
              </div>
            )}

            {/* 닫기 버튼 */}
            {!deploying && deployResult.show && (
              <div style={{textAlign:'right', marginTop:16}}>
                {deployResult.success && (
                  <button onClick={() => window.open('https://worldship.kr/shop', '_blank')} style={{
                    padding:'8px 20px', borderRadius:8, border:'none',
                    background:'#2563eb', color:'#fff', fontSize:13, fontWeight:600,
                    cursor:'pointer', marginRight:8
                  }}>worldship.kr 열기</button>
                )}
                <button onClick={() => setDeployResult({show:false,success:false,message:''})} style={{
                  padding:'8px 20px', borderRadius:8, border:'1px solid #d1d5db',
                  background:'#fff', color:'#374151', fontSize:13, fontWeight:600, cursor:'pointer'
                }}>닫기</button>
              </div>
            )}
            </div>{/* 본문 끝 */}
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
